// extracted by mini-css-extract-plugin
export default {"cc-popbox-confirm":"g0KYxI9b","cc-popbox-confirm-info":"UQCv5tEv"};